import { RESET_APP_STATE } from "static/constants";

export const resetAppState = () => ({ type: RESET_APP_STATE });
